import type { WalletAccount } from '@wallet-standard/core';
import BigNumber from 'bignumber.js';

import { prepareNativeCoinsTransaction } from 'modules/api';
import { Env } from 'modules/common';

import { getConfig } from '../const/getConfig';

export function createStakeTransaction(
  env: Env,
  walletAccount: WalletAccount,
  amount: BigNumber,
) {
  const config = getConfig(env);

  const { transaction, preparedCoins: unstakingCoins } =
    prepareNativeCoinsTransaction({
      walletAccount,
      amount,
    });

  transaction.moveCall({
    target: config.stake.target,
    arguments: [
      transaction.object(config.stake.nativePoolId),
      transaction.object(config.stake.certMetadata),
      transaction.object(config.stake.iotaSystemState),
      unstakingCoins,
    ],
  });
  return { transaction };
}
